import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { School } from '@mui/icons-material';

export function LoadingScreen() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        bgcolor: 'background.default',
        gap: 3,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          mb: 2,
        }}
      >
        <Box
          sx={{
            width: 60,
            height: 60,
            borderRadius: 3,
            bgcolor: 'primary.main',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'primary.contrastText',
          }}
        >
          <School sx={{ fontSize: 32 }} />
        </Box>
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 700, color: 'primary.main' }}>
            AttendEase
          </Typography>
          <Typography variant="subtitle1" color="text.secondary">
            Smart Attendance System
          </Typography>
        </Box>
      </Box>

      <CircularProgress size={40} thickness={4} />
      
      <Typography variant="body2" color="text.secondary">
        Loading your dashboard...
      </Typography>
    </Box>
  );
} 